module.exports = __webpack_public_path__ + "static/media/Basal_4562.429bfc3b.jpg";